// src/components/Navbar.tsx
import React, { useState } from "react";

const Navbar: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const profile = "/images/profileicon.svg";

  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
      <div className="container mx-auto ">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center logo">
            <a href="/" className="text-2xl font-bold text-blue-500">
            </a>
          </div>

          {/* User Dropdown */}
          <div className="relative pr-4">
            {/* <button
              onClick={toggleDropdown}
              className="flex items-center text-gray-600 hover:text-blue-500 focus:outline-none"
            >
              <img
                src={profile}
                alt="User"
                className="h-10 w-10 rounded-full"
              />
            </button> */}
            {isDropdownOpen && (
              <div
                className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg"
                onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing when clicked inside
              >
                <a
                  href="#profile"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Profile
                </a>
                <a
                  href="#settings"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Settings
                </a>
                <a
                  href="#logout"
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Logout
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Close dropdown when clicking outside */}
      {isDropdownOpen && (
        <div
          className="fixed inset-0 z-10"
          onClick={closeDropdown}
          aria-hidden="true"
        ></div>
      )}
    </nav>
  );
};

export default Navbar;
